import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import InputCard from '../components/InputCard';
import { useAuth } from '../contexts/AuthContext';
import PixelAgent from '../components/PixelAgent';

const TEAM = [
  { charIndex: 0, name: 'Super Agent',    role: 'Orchestrator'  },
  { charIndex: 1, name: 'Ideation Agent', role: 'Ideas'         },
  { charIndex: 2, name: 'Research Agent', role: 'Analysis'      },
  { charIndex: 3, name: 'PRD Agent',      role: 'Requirements'  },
  { charIndex: 4, name: 'Design Agent',   role: 'UI/UX'         },
  { charIndex: 5, name: 'Code Agent',     role: 'Engineering'   },
];

const SproutPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleSubmit = (idea) => {
    localStorage.setItem('1prompt_saved_prompt', idea);
    navigate(isAuthenticated ? '/dashboard' : '/auth');
  };

  return (
    <div className="min-h-screen text-[#0F172A] relative overflow-hidden grid-bg">
      {/* Hero */}
      <div className="pt-20 pb-16 px-6 flex flex-col items-center justify-center min-h-screen space-y-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05 }}
          className="text-center space-y-3 max-w-3xl"
        >
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-[#0F172A] leading-[1.08] tracking-[-0.03em]">
            What will you <span className="text-[#2563EB]">build?</span>
          </h1>
          <p className="text-lg text-[#475569]">One prompt in. One working app out.</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="w-full"
        >
          <InputCard onSubmit={handleSubmit} initialIdea="" />
        </motion.div>
      </div>

      {/* Meet the team section */}
      <div id="team" className="border-t border-[#E2E8F0] bg-white/60 px-6 py-14">
        <div className="max-w-4xl mx-auto space-y-8">
          <div className="text-center space-y-1">
            <p className="text-[10px] font-bold text-[#94A3B8] uppercase tracking-widest">The crew</p>
            <h2 className="text-2xl font-extrabold text-[#0F172A] tracking-tight">
              Six agents. One goal.
            </h2>
            <p className="text-sm text-[#475569]">Each agent specialises in one phase — together they ship your app.</p>
          </div>

          <div className="grid grid-cols-3 sm:grid-cols-6 gap-4">
            {TEAM.map((a, i) => (
              <motion.div
                key={a.charIndex}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.05 * i }}
                className="flex flex-col items-center gap-2 group cursor-pointer"
                onClick={() => navigate('/agents')}
              >
                <div className="p-3 rounded-2xl bg-white border border-[#E2E8F0] group-hover:border-[#2563EB]/30 group-hover:bg-[#EFF6FF] transition-all"
                  style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                  <PixelAgent charIndex={a.charIndex} mode="walk" scale={2} />
                </div>
                <div className="text-center">
                  <div className="text-[11px] font-bold text-[#0F172A] leading-tight">{a.name}</div>
                  <div className="text-[10px] text-[#94A3B8]">{a.role}</div>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="text-center">
            <button
              onClick={() => navigate('/agents')}
              className="text-xs font-semibold text-[#2563EB] hover:underline"
            >
              Meet the full team →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SproutPage;
